module.exports = __webpack_public_path__ + "static/media/arrowBack.459b9318.svg";